import React, {useEffect, useState} from 'react';
import "./HeaderNav.scss";
import Logo from "./logo.png";
import LogoWhite from "./logo-white.png";
import {NavLink} from "react-router-dom";
import intl from 'react-intl-universal';
import {DEFAULT_LOCALE, ENGLISH_LOCALE, LANG_MAP, LOCALES_HELPER} from "../../locales/config";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import {RSmartPlus2} from "../../routes/Product/components/RSmartPlus+";




export function HeaderNav() {

    let lan = LOCALES_HELPER.getLan();

    const [first, setFirst] = useState(true);
    const [lang, setlang] = useState({
        type: lan,
        desc: lan === DEFAULT_LOCALE ? LANG_MAP[ENGLISH_LOCALE] : LANG_MAP[DEFAULT_LOCALE]
    });
    
    //隐藏菜单
    function hidemenu(){
        const menu = document.querySelector(".navbar-collapse");
        if(menu){
            menu.classList.remove('in');
        }
    }
    //当页面重新加载时执行
    window.addEventListener('popstate',hidemenu);
    
    function handleSwitchLang() {
        if (lang.type === DEFAULT_LOCALE) {
            setlang({
                type: ENGLISH_LOCALE,
                desc: LANG_MAP[ENGLISH_LOCALE]
            })
        } else {
            setlang({
                type: DEFAULT_LOCALE,
                desc: LANG_MAP[DEFAULT_LOCALE]
            })
        }
        setFirst(false);
    }

    useEffect(() => {
        if (!first) {
            LOCALES_HELPER.setLan(lang.type);
            window.location.reload();
        }
    }, [lang.type])

    
    // useEffect(() => {
    //    const bbb = () =>{
    //     const product = document.getElementById('product');
    //     if(product){
    //         product.style.display = 'none';
    //     } 
    //    };
    //    bbb();
    // }, [])

    return <>
        <header className="menu-header navbar-fixed-top" role="banner">
            <div className="container">
                <nav className="navbar navbar-default" role="navigation">
                    <div className="navbar-header">
                        {/*hamburger button*/}
                        <button type="button" className="navbar-toggle" data-toggle="collapse"
                                data-target=".navbar-collapse">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                        {/* End hamburger button*/}

                        {/*Logo*/}
                        <a className="navbar-brand" href="#">
                            <img src={Logo} alt="" className="main-logo"/>
                            <img src={LogoWhite} alt=""
                                 className="main-logo-light"/>
                        </a>
                        {/* End Logo*/}
                    </div>
                    <div className="collapse navbar-collapse">
                        {/*Main navigation*/}
                        <ul id="menu" className="nav navbar-nav navbar-right">
                            <li className="neko-mega-menu-trigger">
                                {/* <NavLink to={"/index"} activeClassName="active"
                                         className="has-sub-menu">{intl.get('navIndex')}</NavLink> */}
                                <a href="#">{intl.get('navIndex')}</a>
                            </li>
                           
                                
                           
                            <li>
                                {/* <NavLink to={"/about"} activeClassName="active"
                                         className="has-sub-menu">{intl.get('aboutUs')}</NavLink> */}
                                <a href='/#/about'>{intl.get('aboutUs')}</a>
                                {/*<ul className="sub-menu">*/}
                                {/*    <li><a href="#">公司信息</a></li>*/}
                                {/*    <li><a href="#">版本</a></li>*/}
                                {/*</ul>*/}
                            </li>

                            <li className="neko-mega-menu-trigger">
                                <NavLink to={"/product"} activeClassName="active"
                                         className="has-sub-menu">{intl.get('productCenter')}</NavLink>
                                 {/* <a href='/#/product/rpex6'>{intl.get('productCenter')}</a> */}
                                <div
                                    className="neko-mega-menu sub-menu image-background bottom-right no-cover image-30">
                                    <div className="col-md-3">
                                        <div className="mega-inner">
                                            <h2>{intl.get('ggzly')}</h2>
                                            <ul>
                                                {/* <li>
                                                    <NavLink to={"/product/rSmartClassic"} activeClassName="active"
                                                             className="has-sub-menu">R-Smart Classic</NavLink>
                                                </li> */}
                                                {/* <li>
                                                    <NavLink to={"/product/rSmartExpert"} activeClassName="active"
                                                             className="has-sub-menu">R-Smart Expert</NavLink>
                                                </li> */}
                                                {/* <li>
                                                    <NavLink to={"/product/rSmartPro"} activeClassName="active"
                                                             className="has-sub-menu">R-Smart Pro</NavLink>
                                                </li> */}
                                                <li>
                                                    {/* <NavLink to={"/product/rSmartWMate"} activeClassName="active"
                                                             className="has-sub-menu">R-Smart W-Mate</NavLink> */}
                                                    <a href='/#/product/R-SmartMate'>{intl.get('Mate')}</a>
                                                </li>
                                                <li>
                                                    {/* <NavLink to={"/product/rSmartWClassic"} activeClassName="active"
                                                             className="has-sub-menu">R-Smart W-Classic</NavLink> */}
                                                     <a href='/#/product/R-SmartClassic'>{intl.get('Classic')}</a>
                                                </li>
                                                <li>
                                                    {/* <NavLink to={"/product/rSmartWExpert"} activeClassName="active"
                                                             className="has-sub-menu">R-Smart W-Expert</NavLink> */}
                                                     <a href='/#/product/R-SmartExpert'>{intl.get('Expert')}</a>
                                                </li>
                                                <li>
                                                    {/* <NavLink to={"/product/rSmartWPro"} activeClassName="active"
                                                             className="has-sub-menu">R-Smart W-Pro</NavLink> */}
                                                              <a href='/#/product/R-SmartPro'>{intl.get('Pro')}</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/R-SmartMotorE'>{intl.get('RSmartMotorE')}</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/R-SmartMotorS'>{intl.get('RSmartMotorS')}</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/R-SmartMotorAI'>{intl.get('RSmartMotorAI')}</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/R-SmartMax'>{intl.get('RSmartMax')}</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/R-SmartPlus+'>{intl.get('Plus+')}</a>
                                                </li>
                                                <li>
                                            
                                                              <a href='/#/product/MopexE'>{intl.get('MopexE')}</a>
                                                </li>
                                                <li>
                                            
                                                              <a href='/#/product/MopexS'>{intl.get('MopexS')}</a>
                                                </li>
                                                <li>

                                                        <a href='/#/product/MopexW'>{intl.get('MopexW')}</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/MopexAI'>{intl.get('MopexAI')}</a>
                                                </li>
                                                <li>
                                                    {/* <NavLink to={"/product/SMotorE"} activeClassName="active"
                                                             className="has-sub-menu">SMotor E</NavLink> */}
                                                    <a href='/#/product/SMotorE'>{intl.get('SMotor E')}</a>
                                                </li>
                                                <li>
                                                    {/* <NavLink to={"/product/SMotorS"} activeClassName="active"
                                                             className="has-sub-menu">SMotor S</NavLink> */}
                                                    <a href='/#/product/SMotorS'>{intl.get('SMotor S')}</a>
                                                </li>
                                                <li>
                                                    {/* <NavLink to={"/product/SMotorAI"} activeClassName="active"
                                                             className="has-sub-menu">SMotor AI</NavLink> */}
                                                    <a href='/#/product/SMotorAI'>{intl.get('SMotor AI')}</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/RXMax'>{intl.get('RXMax')}</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/RXPlus+'>{intl.get('RXPlus+')}</a>
                                                </li>

                                               
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="mega-inner">
                                            <h2>{intl.get('celiangyi')}</h2>
                                            <ul>
                                                <li>
                                                    {/* <NavLink to={"/product/rpex6"} activeClassName="active"
                                                             className="has-sub-menu">RPEX 6</NavLink> */}
                                                              <a href='/#/product/RPEX6'>RPEX 6</a>
                                                </li>
                                                <li>
                                                    {/* <NavLink to={"/product/rpex9"} activeClassName="active"
                                                             className="has-sub-menu">RPEX 9</NavLink> */}
                                                              <a href='/#/product/RPEX9'>RPEX 9</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="mega-inner">
                                            <h2>{intl.get('ggybj')}</h2>
                                            <ul>
                                                <li>
                                                    {/* <NavLink to={"/product/rSmartMini"} activeClassName="active"
                                                             className="has-sub-menu">R-Smart Mini</NavLink> */}
                                                              <a href='/#/product/R-SmartMini'>R-Smart Mini</a>
                                                </li>
                                                <li>
                                                    {/* <NavLink to={"/product/rSmartPlus"} activeClassName="active"
                                                             className="has-sub-menu">R-Smart Plus</NavLink> */}
                                                              <a href='/#/product/R-SmartPlus'>R-Smart Plus</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/MTMini'>{intl.get('MTMini')}</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/RXPlus'>{intl.get('RXPlus')}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="mega-inner">
                                            <h2>{intl.get('guangguhua')}</h2>
                                            <ul>
                                                <li>
                                                    {/* <NavLink to={"/product/RLED6"} activeClassName="active"
                                                             className="has-sub-menu">RLED 6</NavLink> */}
                                                              <a href='/#/product/RLED6'>RLED 6</a>
                                                </li>
                                                <li>
                                                    {/* <NavLink to={"/product/MCure1"} activeClassName="active"
                                                             className="has-sub-menu">M-Cure1</NavLink> */}
                                                              <a href='/#/product/M-Cure1'>M-Cure 1</a>
                                                </li>
                                                <li>
                                                    {/* <NavLink to={"/product/MCure3"} activeClassName="active"
                                                             className="has-sub-menu">M-Cure3</NavLink> */}
                                                              <a href='/#/product/M-Cure3'>M-Cure 3</a>
                                                </li>
                                                <li>

                                                       <a href='/#/product/M-Cure6'>{intl.get('MCure6')}</a>
                                                </li>
                                                <li>
                                                    {/* <NavLink to={"/product/MCure8"} activeClassName="active"
                                                             className="has-sub-menu">M-Cure8</NavLink> */}
                                                              <a href='/#/product/M-Cure8'>M-Cure 8</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/M-Cure9'>{intl.get('MCure9')}</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/M-CureLX'>{intl.get('MCureLX')}</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/M-CureL1'>{intl.get('MCureL1')}</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/M-CureT5'>{intl.get('MCureT5')}</a>
                                                </li>
                                                <li>

                                                    <a href='/#/product/M-CureT7'>{intl.get('MCureT7')}</a>
                                                </li>
                                                <li>
                                                   
                                                              <a href='/#/product/MC1'>{intl.get('MC1')}</a>
                                                </li>
                                                <li>
                                                   
                                                                <a href='/#/product/MC3'>{intl.get('MC3')}</a>
                                                </li>
                                                <li>
                                                   
                                                                <a href='/#/product/MC8'>{intl.get('MC8')}</a>
                                                </li>
                                                <li>
                                                   
                                                                <a href='/#/product/MC9'>{intl.get('MC9')}</a>
                                                </li>
                                                <li>
                                                   
                                                                <a href='/#/product/MX'>{intl.get('MX')}</a>
                                                </li>
                                                <li>
                                                   
                                                            <a href='/#/product/MCT5'>{intl.get('MC T5')}</a>
                                                </li>
                                                <li>
                                                   
                                                                <a href='/#/product/MCT7'>{intl.get('MC T7')}</a>
                                                </li>
                                                <li>

                                                                 <a href='/#/product/MCL1'>{intl.get('MCL1')}</a>
                                                </li>


                                            </ul>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="mega-inner">
                                            <h2>{intl.get('dxq')}</h2>
                                            <ul>
                                                <li>
                                                    {/* <NavLink to={"/product/dxq"} activeClassName="active"
                                                             className="has-sub-menu">{intl.get('dxq r6')}</NavLink> */}
                                                              <a href='/#/product/UltraR6'>{intl.get('dxq r6')}</a>
                                                            
                                                </li>
                                                <li>
                                                    {/* <NavLink to={"/product/R3"} activeClassName="active"
                                                             className="has-sub-menu">{intl.get('r3-series')}</NavLink> */}
                                                              <a href='/#/product/Ultra3'>{intl.get('r3-series')}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-3">
                                        <div className="mega-inner">
                                            <h2>{intl.get('ggcz')}</h2>
                                            <ul>
                                               
                                            </ul>
                                        </div>
                                    </div> */}

                                </div>
                            </li>
                            <li>
                                <NavLink to={"/service"} activeClassName="active"
                                         className="has-sub-menu">{intl.get('userService')}</NavLink>
                                          {/* <a href='/#/service'>{intl.get('userService')}</a> */}
                                <ul className="sub-menu">
                                    <li>
                                        {/* <NavLink to={"/service/after"} activeClassName="active"
                                                 className="has-sub-menu">{intl.get('shfw')}</NavLink> */}
                                                  <a href='/#/service/after'>{intl.get('shfw')}</a>
                                    </li>

                                    <li>
                                        {/* <NavLink to={"/service/qa"} activeClassName="active"
                                                 className="has-sub-menu">{intl.get('cjwt')}</NavLink> */}
                                                  <a href='/#/service/QA'>{intl.get('cjwt')}</a>
                                        {/* <NavLink to={"/service/case"} activeClassName="active"
                                                 className="has-sub-menu">{intl.get('cases')}</NavLink> */}
                                                  <a href='/#/service/case'>{intl.get('cases')}</a>
                                    </li>

                                    {/*<li>*/}
                                    {/*    <a href="#">下载中心</a>*/}
                                    {/*    <ul className="sub-menu">*/}
                                    {/*        <li><a href="#">固件1</a></li>*/}
                                    {/*        <li><a href="#">固件2</a></li>*/}
                                    {/*        <li><a href="#">固件3</a></li>*/}
                                    {/*    </ul>*/}
                                    {/*</li>*/}
                                </ul>
                            </li>

                            <li>
                                {/* <NavLink to={"/news"} activeClassName="active"
                                         className="has-sub-menu">{intl.get('newsCenter')}</NavLink> */}
                                          <a href='/#/news'>{intl.get('newsCenter')}</a>
                            </li>

                            <li>
                                <NavLink to={"/contact"} activeClassName="active"
                                         className="has-sub-menu">{intl.get('contactUs')}</NavLink>
                                          {/* <a href='/#/contact'>{intl.get('contactUs')}</a> */}
                                <ul className="sub-menu">
                                    <li>
                                        {/* <NavLink to={"/contact/us"} activeClassName="active"
                                                 className="has-sub-menu">{intl.get('contactUs')}</NavLink> */}
                                                  <a href='/#/contact/us'>{intl.get('contactUs')}</a>
                                    </li>

                                    {lan === DEFAULT_LOCALE
                                        ?
                                        <li>
                                        {/* <NavLink to={"/contact/hire"} activeClassName="active"
                                                 className="has-sub-menu">{intl.get('zpxx')}</NavLink> */}
                                                  <a href='/#/contact/hire'>{intl.get('zpxx')}</a>
                                        </li>
                                        :""
                                    }
                                </ul>
                            </li>

                            <li><a
                                onClick={handleSwitchLang}
                                className="btn border small">{lang.desc}</a></li>

                        </ul>
                        {/*End main navigation*/}
                    </div>


                </nav>
            </div>

        </header>
    </>
}


